import '../../styles.css';
import SvgIcon, { iconList } from "../../../share/components/iconSVG";
import usePaymentCards from '../../../../viewModels/profile/payment.cards.viewModel';
import ModalContainer from '../../../share/components/modalContainer';
import AdminPaymentCards from '../adminPaymentCards';
import ActivityIndicator from '../../../share/components/activityIndicator';

function PaymentCards({
  selectItem = false,
  selected = false
}) {
  const {

    cardsRegisteredList,
    isOpenModal,
    setIsOpenModal,
    addCard,
    getResponsePaymentezAdd,
    userDetail,

    isFetchign,
    isDeleting,
    isSendingCard,
    deleteCard,
    message,
    successfull,
  } = usePaymentCards();


  const cardSelected = selected
  return (
    <>
      {isOpenModal &&
        <ModalContainer
          show={isOpenModal}
          hidden={setIsOpenModal}
          sizeWidth={50}
          sizeHeight={60}
        >
          {isSendingCard
            ? <div>
              {!successfull && message === ''
                ? <ActivityIndicator colorFill='#004274' size={80} />
                : <div className='modalStatus'>

                  {successfull
                    ? <SvgIcon name={iconList.IconCheckSucces} size={120} color={'#58D68D'} />
                    : <SvgIcon name={iconList.IconCloseCircleOutLine} size={120} color={'#EC7063'} />
                  }
                  <p className='modalStatusText'>{message}</p>
                </div>
              }
            </div>
            : <AdminPaymentCards
              user={userDetail}
              catchResponse={getResponsePaymentezAdd}
            />
          }
        </ModalContainer>
      }
      <div className="profileScreen_CardShadow listCard">
        <div className="listCardHeader">
          {isFetchign
            ? <ActivityIndicator colorFill='#004274' size={20} />
            : <p className="listCardHeaderText">Metodos de pago</p>
          }
        </div>
        <div className="listCardBody">
          {cardsRegisteredList.length > 0 ?
            cardsRegisteredList.map((index, key) => {
              const isSelected = cardSelected?.id === index?.id
              const allCount = cardsRegisteredList.length;
              const today = new Date();
              const day = ("0" + today.getDate()).slice(-2);
              const month = ("0" + (today.getMonth() + 1)).slice(-2);
              const year = today.getFullYear();
              const _Today = `${year}-${month}-${day}`;

              if(selectItem && cardsRegisteredList.length === 1){
                selectItem(index);
              }else if(selectItem && allCount === key+1 && index.created_at.split('T')[0] === _Today ){
                selectItem(index);               
              }
              return (
                <div key={key} className="listCardBodyElemt">
                  {selectItem &&
                    <div>
                      {isSelected &&
                        <SvgIcon name={iconList.IconCheckSucces} size={25} color={'#004274'} />
                      }
                    </div>
                  }
                  <p className="listCardBodyElemtText">xxxx xxxx xxxx {index?.number}</p>
                  <div className='listCardBodyElemtOptions'>
                    <div onClick={() => deleteCard(index?.id)} className='listCardBodyElemtBtn'>
                      {isDeleting == index.id
                        ? <ActivityIndicator colorFill='#004274' size={20} />
                        : <SvgIcon name={iconList.IconTrashOutLine} size={25} color={'#004274'} />
                      }
                    </div>
                    {selectItem &&
                      <div onClick={() => selectItem(index)} className='listCardBodyElemtBtn'>
                        <div>
                          <SvgIcon name={iconList.IconPlusCircleOutLine} size={25} color={'#004274'} />
                        </div>
                      </div>
                    }
                  </div>
                </div>
              )
            })
            :
            <div className='arrayEmpty'>
              <p className='arrayEmptyText'>No hay metodos de pago registrados aun!</p>
            </div>
          }
        </div>
        <div className="listCardFooter">
          <div className="listCardFooterBtn" onClick={addCard}>
            <SvgIcon name={iconList.IconPlusCircleOutLine} size={25} color={'#004274'} />
            <p className="listCardFooterBtnText">Añadir método de pago</p>
          </div>
        </div>
      </div>
    </>
  )
}
export default PaymentCards;